import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, MapPin } from 'lucide-react';

const HeroSection = () => {
  const scrollToBooking = () => {
    document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/1vt6w7zn_IMG_3360.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black via-black/90 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          {/* Logo/Brand */}
          <div className="mb-6 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/cx4vxfkk_IMG_3114.png"
              alt="Gio's Car Detailing Logo"
              className="w-48 h-48 md:w-64 md:h-64 object-contain drop-shadow-2xl"
            />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 via-yellow-400 to-amber-300">
              Gio's Car Detailing
            </span>
          </h1>
          
          {/* Tagline */}
          <p className="text-2xl md:text-3xl text-gray-300 mb-6 font-light">
            Showroom Shine, Delivered to Your Door
          </p>
          
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
            Premium mobile detailing service that brings professional results directly to you. 
            Experience luxury care for your vehicle without leaving your home.
          </p>

          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-yellow-500/20 to-amber-400/20 backdrop-blur-sm border border-yellow-500/30 mb-12">
            <MapPin className="w-5 h-5 text-yellow-400" />
            <span className="text-yellow-400 font-medium">Mobile Service - We Come to You</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button 
              onClick={scrollToBooking}
              className="bg-gradient-to-r from-yellow-500 to-amber-400 hover:from-yellow-600 hover:to-amber-500 text-black font-bold text-lg px-8 py-6 rounded-lg shadow-lg shadow-yellow-500/30 transition-all duration-300 hover:shadow-yellow-500/50 hover:scale-105"
            >
              Book Your Detail
            </Button>
            <Button 
              onClick={scrollToServices}
              variant="outline" 
              className="border-2 border-yellow-500 text-yellow-400 hover:bg-yellow-500/10 font-semibold text-lg px-8 py-6 rounded-lg transition-all duration-300"
            >
              View Services
            </Button>
          </div>
        </div>

        {/* Glassmorphism Contact Card */}
        <div className="max-w-4xl mx-auto">
          <div className="backdrop-blur-xl bg-white/5 border border-yellow-500/20 rounded-2xl p-8 shadow-2xl">
            <h3 className="text-2xl font-bold text-yellow-400 mb-6 text-center">Get in Touch</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center group cursor-pointer">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500/20 to-amber-400/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Phone className="w-8 h-8 text-yellow-400" />
                </div>
                <p className="text-gray-400 text-sm mb-2">Call Us</p>
                <a href="tel:4439421539" className="text-white font-semibold hover:text-yellow-400 transition-colors">
                  (443) 942-1539
                </a>
              </div>
              
              <div className="flex flex-col items-center text-center group cursor-pointer">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500/20 to-amber-400/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Mail className="w-8 h-8 text-yellow-400" />
                </div>
                <p className="text-gray-400 text-sm mb-2">Email Us</p>
                <a href="mailto:jasonhines1008@gmail.com" className="text-white font-semibold hover:text-yellow-400 transition-colors break-all">
                  jasonhines1008@gmail.com
                </a>
              </div>
              
              <div className="flex flex-col items-center text-center group cursor-pointer">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500/20 to-amber-400/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="w-8 h-8 text-yellow-400" />
                </div>
                <p className="text-gray-400 text-sm mb-2">Service Area</p>
                <p className="text-white font-semibold">Mobile Service</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
    </div>
  );
};

export default HeroSection;
